import { Building2, CreditCard, Euro, Landmark, Smartphone } from 'lucide-react';

export const paymentMethods = [
  {
    value: 'card' as const,
    icon: CreditCard,
    labelKey: 'paymentMethod.card',
    descriptionKey: 'paymentMethod.cardDescription',
  },
  {
    value: 'sepa' as const,
    icon: Euro,
    labelKey: 'paymentMethod.sepa',
    descriptionKey: 'paymentMethod.sepaDescription',
  },
  {
    value: 'multibanco' as const,
    icon: Landmark,
    labelKey: 'paymentMethod.multibanco',
    descriptionKey: 'paymentMethod.multibancoDescription',
  },
  {
    value: 'mb_way' as const,
    icon: Smartphone,
    labelKey: 'paymentMethod.mb_way',
    descriptionKey: 'paymentMethod.mb_wayDescription',
  },
  {
    value: 'bacs' as const,
    icon: Building2,
    labelKey: 'paymentMethod.bacs',
    descriptionKey: 'paymentMethod.bacsDescription',
  },
] as const;
